module.exports = __webpack_public_path__ + "img/sistemIgreja.097a010e.webp";